import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ButtonsCrud from "../../../components/Catalogs/ButtonsCrud";
import '../../../assets/css/AddCatalogs.css';
import Input from "../../../components/Atomos/Inputs/Input";
import SaveOverride from "../../../components/Catalogs/SaveOverride";
import CatalogSubTitle from "../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import { getCurrentTimestamp } from "../../../utils/functions";
import { IContentGeneralTopic } from "../../../interfaces";
import { useDispatch } from "react-redux";
import { AddContentGeneralTopics, DeleteContentGeneralTopics, UpdateContentGeneralTopics } from "../../../redux/catalogs/states";
import { addContentGeneralTopics, deleteContentGeneralTopics, updateContentGeneralTopics } from "../../../Services/ContentGeneralTopic";

interface iCatalogProps {
  mode: "add" | "edit";
}
type Errors = { name: { error: boolean; message: string; };}

const AddContentGeneralTopic: React.FC<iCatalogProps> = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state, pathname } = useLocation();
  const [errors, setErrors] = useState<Errors>({ name: { error: false, message: '' }});
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [error, setError] = useState(false);
  const [contentGeneralTopic, setContentGeneralTopic] = useState<IContentGeneralTopic>({ id: state?.id ?? '', name: state?.name ?? '' });
  const [buttonClicked, setButtonClicked] = useState('');
  const [saveOverrideOpen, setSaveOverrideOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (contentGeneralTopic.name?.trim() !== '') {
      setErrors({ ...errors, name: { error: false, message: '' } });
    }
  }, [contentGeneralTopic]);

  const validation = () => {

    const name = contentGeneralTopic.name?.trim() === '' ? { error: true, message: 'Name is required' } : { error: false, message: '' };

    setErrors({ name: name });
    setError(name.error);
    return name.error;
  }

  const handleDelete = async (id: string) => {
    try {
      await deleteContentGeneralTopics(state.id);
      dispatch(DeleteContentGeneralTopics(state.id));
      navigate(-1);
    } catch (error: any) {
      console.error(error);
    }
  }

  const handleButtonClick = (buttonName: string) => {
    setButtonClicked(buttonName);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (buttonClicked === 'saveOverride') {
      if (props.mode === 'add') {
        handleSave(e);
      }
      else {
        handleUpdate(e);
      }
    }

    if (buttonClicked === 'updateButton') {
      handleUpdate(e);
    } else if (buttonClicked === 'saveButton') {
      handleSave(e);
    }
  };

  const handleSave = async (event: React.FormEvent<HTMLFormElement>) => {
    if (buttonClicked !== 'saveOverride' && validation()) {
      return
    }
    try {
      const generalTopic: IContentGeneralTopic = {...contentGeneralTopic, createdDate: getCurrentTimestamp()};
      const response = await addContentGeneralTopics(generalTopic);
      dispatch(AddContentGeneralTopics(response));
      navigate(-1);
    } catch (error: any) {
      if (error.message.includes('Name')) {
        setErrors({ ...errors, name: { error: true, message: 'Name already exists' } });
      } else {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    if (errors.name.error) {
      setSaveOverrideOpen(true)
    }
    else {
      setSaveOverrideOpen(false)
      if (error) {
        setError(false)
      }
    }
  }
    , [errors]);

  const handleUpdate = async (event: React.FormEvent<HTMLFormElement>) => {
    if (buttonClicked !== 'saveOverride' && validation()) {
      return
    }
    try {
      await updateContentGeneralTopics(contentGeneralTopic);
      dispatch(UpdateContentGeneralTopics(contentGeneralTopic));
      navigate(-1);
    } catch (error: any) {
      if (error.message.includes('Name')) {
        setErrors({ ...errors, name: { error: true, message: 'Name already exists' } });
      } else {
        console.error(error);
      }
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    if (error) {
      validation();
    }
    setContentGeneralTopic({ ...contentGeneralTopic, [e.target.name]: e.target.value });
  }

  const handleCloseSaveOverride = () => {
    setSaveOverrideOpen(!saveOverrideOpen);
  }

  useEffect(() => {
    const errorsToSet = Object.keys(errors).filter((clave) => errors[clave as keyof typeof errors].error);
    console.log(errorsToSet);
    setErrorFields(errorsToSet);
  }, [errors]);

  return (
    <>
      <div className={`${saveOverrideOpen ? 'pt-7 md:pt-9 ' : ''}`}>
        <form onSubmit={handleSubmit}>
          <SaveOverride fields={errorFields} handleButtonClick={handleButtonClick} open={saveOverrideOpen} close={handleCloseSaveOverride} />

          <article className='articleSection '>
            <section className='formsectionNTitle '>
              <CatalogSubTitle title="Content General Topic Information" className=" text-accent-Default-dark" />
              <div className="formsection flex w-full">
                <div className=" w-full">
                  <Input name="name" title="Name" value={contentGeneralTopic.name} required={true} error={errors.name.error} errorMsj={errors.name.message} onChange={handleInputChange} />
                </div>
              </div>
              <ButtonsCrud
                Catalog="ContentGeneralTopic"
                mode={props.mode}
                id={id ? id : ""}
                disabled={errors.name.error}
                actionButton={handleButtonClick}
                onDelete={handleDelete}
                state={state}
                newState={contentGeneralTopic}
              />
            </section>
          </article>
        </form>
      </div>
    </>
  );
}

export default AddContentGeneralTopic;